// extracted by mini-css-extract-plugin
module.exports = {"header":"SharedLinkViewer_header__3YKFz","headerTitle":"SharedLinkViewer_headerTitle__3rmSq"};